import { SupportConfigOpperationItem } from "./SupportConfigOperation";

export const SupportConfigOperationScreen = () => {
  return <SupportConfigOpperationItem />;
};
